/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import {
  Dialog,
  FilledButton,
  OutlinedButton,
  TimeZonePicker,
} from '@neo4j-ndl/react';
import { useRef, useState } from 'react';

const Component = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedTimeZone, setSelectedTimeZone] = useState<string>('UTC');
  const [tempTimeZone, setTempTimeZone] = useState<string>('UTC');
  const ref = useRef<HTMLDivElement | null>(null);

  const handleOpen = () => {
    setTempTimeZone(selectedTimeZone);
    setIsOpen(true);
  };

  const handleClose = () => setIsOpen(false);

  const handleSave = () => {
    setSelectedTimeZone(tempTimeZone);
    setIsOpen(false);
  };

  const handleTimeZoneChange = (timezone: string) => {
    setTempTimeZone(timezone);
  };

  return (
    <div
      ref={ref}
      className="n-flex n-flex-col n-items-center n-justify-center n-relative n-h-[500px] n-w-full"
    >
      <div className="n-flex n-flex-col n-items-center n-gap-4">
        <FilledButton onClick={handleOpen}>Select Timezone</FilledButton>
        <div>
          <p>Selected Timezone: {selectedTimeZone}</p>
        </div>
      </div>
      <Dialog
        onClose={handleClose}
        isOpen={isOpen}
        container={ref?.current || undefined}
        size="medium"
      >
        <Dialog.Header>Select Timezone</Dialog.Header>
        <Dialog.Description>
          Choose a timezone from the list below
        </Dialog.Description>
        <Dialog.Content>
          <TimeZonePicker
            label="Timezone"
            value={tempTimeZone}
            onChange={handleTimeZoneChange}
            isFluid
          />
        </Dialog.Content>
        <Dialog.Actions>
          <OutlinedButton onClick={handleClose} variant="neutral" size="medium">
            Cancel
          </OutlinedButton>
          <FilledButton onClick={handleSave} size="medium">
            Save
          </FilledButton>
        </Dialog.Actions>
      </Dialog>
    </div>
  );
};

export default Component;
